import { render, staticRenderFns } from "./RendicionItem.vue?vue&type=template&id=130eaaf7&scoped=true&"
import script from "./RendicionItem.vue?vue&type=script&lang=js&"
export * from "./RendicionItem.vue?vue&type=script&lang=js&"
import style0 from "./RendicionItem.vue?vue&type=style&index=0&id=130eaaf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130eaaf7",
  null
  
)

export default component.exports